export { default } from '../Fabrics';



// WEBPACK FOOTER //
// ./src/components/async/Fabrics.js